<template>
	<v-footer app>
		<br /><br />
		<h6 class="unselectable">&copy; RESTful College, 2021</h6>
	</v-footer>
</template>

<script>
export default {
	name: "MyFooter"
};
</script>

<style></style>
